<script lang="ts">
  export let size = 20;
</script>

<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.666 6.79325H11.7393C10.1593 6.79325 8.87268 5.50659 8.87268 3.92659V1.99992C8.87268 1.63325 8.57268 1.33325 8.20602 1.33325H5.37935C3.32602 1.33325 1.66602 2.66659 1.66602 5.04659V10.9533C1.66602 13.3333 3.32602 14.6666 5.37935 14.6666H10.6193C12.6727 14.6666 14.3327 13.3333 14.3327 10.9533V7.45992C14.3327 7.09325 14.0327 6.79325 13.666 6.79325Z"
    class={$$props.class || "fill-current"}
  />
  <path
    d="M10.5338 1.47341C10.2604 1.20008 9.78711 1.38674 9.78711 1.76674V4.09341C9.78711 5.06674 10.6138 5.87341 11.6204 5.87341C12.2538 5.88008 13.1338 5.88008 13.8871 5.88008C14.2671 5.88008 14.4671 5.43341 14.2004 5.16674C13.2404 4.20008 11.5204 2.46008 10.5338 1.47341Z"
    class={$$props.class || "fill-current"}
  />
</svg>
